import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.624 0.376006C17.1226 -0.125351 16.3098 -0.125319 15.8084 0.376006L8.99999 7.18442L2.19159 0.376026C1.69025 -0.125332 0.877395 -0.125332 0.376021 0.376026C-0.125352 0.877415 -0.12533 1.69026 0.376024 2.19162L7.18442 8.99999L0.376044 15.8084C-0.125304 16.3097 -0.125329 17.1226 0.376044 17.6239C0.877414 18.1253 1.69027 18.1253 2.19162 17.6239L8.99999 10.8155L15.8084 17.6239C16.3097 18.1253 17.1226 18.1253 17.624 17.6239C18.1253 17.1226 18.1253 16.3097 17.624 15.8084L10.8156 8.99999L17.624 2.19158C18.1253 1.69022 18.1254 0.877395 17.624 0.376006Z",
		fill: "#333333"
	})
});
export default SvgClose;
